import React from "react";

import { FormattedMessage } from "react-intl";
import { VerificationService } from "../../../lib/types/types";
import { FormFooterComponent } from "../../FormFooter/FormFooterComponent";

export interface IdCheckLoopRegulaFooterProps {
  verificationService: VerificationService;
}

export const IdCheckLoopRegulaFooter = ({ verificationService }: IdCheckLoopRegulaFooterProps) => (
  <FormFooterComponent verificationService={verificationService}>
    <div>
      <p>
        <FormattedMessage
          id="step.idCheckLoop.regula.terms"
          defaultMessage='By clicking "Continue", you agree you have read, understand, and accept the {privacyPolicyLink} and {termsOfService}.'
          values={{
            privacyPolicyLink: (
              <a
                href="https://regulaforensics.com/privacy/"
                target="_blank"
                rel="noopener noreferrer"
                className="sid-link"
              >
                <FormattedMessage
                  id="step.idCheckLoop.privacyPolicy"
                  defaultMessage="Privacy Policy"
                />
              </a>
            ),
            termsOfService: (
              <a
                href="https://regulaforensics.com/terms-of-use/"
                target="_blank"
                rel="noopener noreferrer"
                className="sid-link"
              >
                <FormattedMessage
                  id="step.idCheckLoop.termsOfService"
                  defaultMessage="Terms of Service"
                />
              </a>
            ),
          }}
        />
      </p>

      <p>
        <FormattedMessage id="companyName" defaultMessage="{Company}">
          {(companyName) => (
            <FormattedMessage
              id="step.idCheckLoop.disclaimer"
              defaultMessage="SheerID, {companyName}'s trusted partner, use a third party, {serviceType}, to process our identity check."
              values={{
                serviceType: "Regula",
                companyName,
              }}
            />
          )}
        </FormattedMessage>
      </p>
    </div>
  </FormFooterComponent>
);

export default IdCheckLoopRegulaFooter;
